import React from "react";

const DelayedIcon = () => {
  return (
    <>
      <svg width="22" height="22" viewBox="0 0 22 22">
        <path
          id="Path_2514"
          data-name="Path 2514"
          d="M11.9,7.5v6.6l5.72,3.41.88-1.32-4.95-2.97V7.5ZM21.8,13v6.6H24V13Zm0,8.8V24H24V21.8Zm-2.2,0A10.6,10.6,0,0,1,13,24,11,11,0,1,1,23.78,10.8H21.47A8.778,8.778,0,1,0,13,21.8a9.056,9.056,0,0,0,6.6-2.97Z"
          transform="translate(-2 -2)"
          fill="#fff"
        />
      </svg>
    </>
  );
};

export default DelayedIcon;
